export { useLoyaltyHomeProgressBarAnimation } from './useLoyaltyHomeProgressBarAnimation';
